import { apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_Facility, DBDef_Facility } from '@app/org-shared';
export const dispatch_onFacilityChanged = new ThunderDispatcherV3('__onFacilityUpdated');
export class ModuleFE_Facility_Class extends ModuleFE_BaseApi {
    _v1;
    __searchFilterMapper = (item) => [item.name];
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => ({ _id: i._id, uiLabel: i.name }))
        }]);
    constructor() {
        super(DBDef_Facility, dispatch_onFacilityChanged);
        this._v1 = {
            getQuaiFacilities: apiWithQuery(ApiDef_Facility._v1.getQuaiFacilities),
            getFacility: apiWithQuery(ApiDef_Facility._v1.getFacility)
        };
    }
}
export const ModuleFE_Facility = new ModuleFE_Facility_Class();
//# sourceMappingURL=ModuleFE_Facility.js.map